if ('undefined' == typeof CardOptions) {
	class CardOptions {
		constructor() {
			const options = document.querySelectorAll('.card-options input[type="radio"]');
			options.forEach(this.clickHandler);
		}
		clickHandler(option) {
			if (option) {
				option.addEventListener('click', (event) => {
          
          let card = event.target.closest('.card');
          let images = card.querySelectorAll('.card__media .primary');
          let badges = card.querySelectorAll('.variant-badge');
          let variantId = parseInt(option.dataset.variantId);

          card.querySelector('.product-variant-select').value = variantId;

          //console.log(`Variant changed to ${variantId}, ${option.value}`);

          // Update data attributes of the card
          card.dataset.option = option.value;
          card.dataset.variantId = variantId;

          // Update card badges visibility
          if (badges) {
            badges.forEach(badge => {
              const badgeID = parseInt(badge.dataset.variantId);
              if (variantId === badgeID) {
                badge.classList.remove('disabled');
              } else {
                badge.classList.add('disabled');
              }
            });
          }

          // Update image visibility
          if (images) {
            images.forEach(image => {
              const imageVariantId = parseInt(image.dataset.variantId);
              if (variantId === imageVariantId) {
                image.classList.remove('disabled');
              } else {
                image.classList.add('disabled');
              }
            });
          }


				});
			}
		}
	}
  const cardOptions = new CardOptions;
  window.theme.components = window.theme.components || {};
  window.theme.components.cardOptions = cardOptions;
  window.theme.components.cardOptions.clickHandler();
}
